const get_id = (uni_cookies) => {
  let id = uni_cookies.get('pajoohyar_id');
  if (id === undefined) {
    id = Date.now();
    for (let i = 0; i < 100; i++) {
      id += Math.random() * 8;
      id += Math.random() * 32;
      id += Math.random() * 256;
      id += Math.random() * 512;
      id += Math.random() * 1024;
      id += Math.random() * 2048;
    }
    id = parseInt(id);
  }
  uni_cookies.set('pajoohyar_id', id);
  return (id);
}
const get_url = () => {
  const url = document.getElementById('url').value;
  return url;
}

const get_token = (uni_cookies) => {
  return uni_cookies.get('pajoohyar_token', 'NuLL');
}
const set_token = (uni_cookies, my_token) => {
  uni_cookies.set('pajoohyar_token', my_token);
}
const update_profile = (uni_cookies, resolve) => {
  const token = get_token(uni_cookies);
  var data = JSON.stringify({});

  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;
  
  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === this.DONE) {
      const info = JSON.parse(this.responseText);
      uni_cookies.set('pajoohyar_profile', info);
      resolve(info);
    }
  });
  const url = document.getElementById('url').value;
  xhr.open("GET", `${url}/api/auth/me`);
  xhr.setRequestHeader("authorization", `Bearer ${token}`);
  xhr.setRequestHeader("content-type", "application/json");
  xhr.setRequestHeader("accept", "application/json");
  xhr.send(data);
}
const get_profile = (uni_cookies) => {
  return uni_cookies.get('pajoohyar_profile', 'None');
}
module.exports = {
  get_id,
  get_url,
  set_token,
  get_token,
  update_profile,
  get_profile,
}